import { useState, useEffect } from 'react'

export const useStatsData = (playerId = null) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        
        if (playerId) {
          const response = await fetch(`/data/${playerId}_stats.json`)
          if (!response.ok) throw new Error(`Failed to load player ${playerId}`)
          const playerData = await response.json()
          setData(playerData)
        } else {
          // Load all available players from config
          const playerIds = ['3700', '12113', '18653', '12903', '14972', '76465', '19001', '5868', 
                            '14140', '20161', '100002', '712', '109061', '109063', '18437', '118307', 
                            '109062', '11258', '119621', '10369', '7027', '23758', '2664', '119622', 
                            '137047', '116415', '110399', '136109', '110400', '80122']
          const promises = playerIds.map(async id => {
            try {
              const response = await fetch(`/data/${id}_stats.json`)
              if (!response.ok) return null
              return await response.json()
            } catch {
              return null
            }
          })
          const results = await Promise.all(promises)
          const allData = results.filter(Boolean) // Remove null entries
          setData(allData)
        }
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [playerId])

  return { data, loading, error }
}